/* eslint-disable prefer-promise-reject-errors,no-console,no-restricted-syntax */
import qs from 'qs';

const getForm = (target) => {
  let form;
  if (typeof target === 'string') form = document.forms[target];
  else form = target;
  if (!(form instanceof HTMLFormElement)) throw Error('form 요소가 아닙니다');
  return form;
};

export default {
  validate: (target) => {
    const list = getForm(target).elements;
    let i;
    let l;
    let e;
    const r = {};
    for (i = 0, l = list.length; i < l; i += 1) {
      e = list[i];
      if (e.name && !e.getAttribute('data-optional')) {
        switch (e.nodeName) {
          case 'INPUT':
            switch (e.type) {
              case 'radio':
                if (!r[e.name]) r[e.name] = e.checked;
                break;
              case 'checkbox':
                break;
              default:
                if (e.value === '') {
                  try {
                    e.focus();
                  } catch ($e) { console.error($e); }
                  return e.name;
                }
                break;
            }
            break;
          case 'TEXTAREA':
          case 'SELECT':
            if (e.value === '') {
              try {
                e.focus();
              } catch ($e) { console.error($e); }
              return e.name;
            }
            break;
          default:
        }
      }
    }
    for (i in r) {
      if (!r[i]) return i;
    }
    return false;
  },
  jsonp: (() => {
    let rSeq = 0;
    let head;

    const getHead = () => {
      if (!head) [head] = document.getElementsByTagName('head');
      return head;
    };

    return ($url, $params, $callback, $callbackName) => {
      const tag = document.createElement('script');
      tag.type = 'text/javascript';
      let url = $url;
      if ($params) url += `?${qs.stringify($params)}`;
      if ($callback) {
        const cb = `ox_jp_cb${rSeq += 1}`;
        const callbackName = $callbackName || 'callback';
        window[cb] = ($r) => {
          $callback($r);
          delete window[cb];
        };
        url += `${($params ? '&' : '?') + callbackName}=${cb}`;
      }
      tag.src = url;
      getHead().appendChild(tag);
    };
  })(),
  submit: (() => {
    const frameName = '__OX_SUBMIT__';
    let frame;
    let initialized;
    let seq = 0;

    const init = () => {
      if (initialized) return;
      initialized = true;
      frame = document.createElement('iframe');
      frame.style.display = 'none';
      frame.name = frameName;
      document.body.appendChild(frame);
    };

    return (target) => {
      init();
      const form = getForm(target);
      form.target = frameName;
      if (!form.OX_SUBMIT) {
        const cbi = document.createElement('input');
        cbi.type = 'hidden';
        cbi.name = 'OX_SUBMIT';
        form.appendChild(cbi);
      }
      const cb = `OX_SUBMIT_CB_${seq}`;
      seq += 1;
      form.OX_SUBMIT.value = cb;
      return new Promise((resolve, reject) => {
        window[cb] = ($r) => {
          if ($r.status === 'OK') {
            resolve($r);
          } else {
            reject($r);
          }
        };
        form.submit();
      });
    };
  })(),
};



// WEBPACK FOOTER //
// ./src/util/oxizen.js